/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsFindYourIssueType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/FindYourIssuePage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - find-your-issue page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsFindYourIssue: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof PlanSettingsFindYourIssueType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-plan-settings-find-your-issue", jiraSpaEntry: "async-plan-settings-plan-settings-find-your-issue" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/FindYourIssuePage.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsFindYourIssue = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsFindYourIssue}
		pageId="plan-settings-find-your-issue"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsFindYourIssue;
